import { useEffect, useState } from 'react'
import { Link, Navigate, useSearchParams } from 'react-router-dom'
import { useAuth } from '@/auth/AuthContext'
import { SettingsShell } from '@/components/SettingsShell'
import {
  getRememberedSettingsCustomer,
  rememberSettingsCustomer,
} from '@/settingsContext'

function IconUsers() {
  return (
    <svg className="h-7 w-7 text-sky-700" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.75" aria-hidden>
      <path strokeLinecap="round" strokeLinejoin="round" d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z" />
    </svg>
  )
}

function IconCustomers() {
  return (
    <svg className="h-7 w-7 text-sky-700" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.75" aria-hidden>
      <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 21h19.5m-18-18v18m10.5-18v18m6-13.5V21M6.75 6.75h.75m-.75 3h.75m-.75 3h.75m3-6h.75m-.75 3h.75m-.75 3h.75M6.75 21v-3.375c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21M3 3h12m-.75 4.5H21m-3.75 0h.008v.008h-.008v-.008zm0 3h.008v.008h-.008v-.008zm0 3h.008v.008h-.008v-.008z" />
    </svg>
  )
}

function IconCategories() {
  return (
    <svg className="h-7 w-7 text-sky-700" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.75" aria-hidden>
      <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
    </svg>
  )
}

function IconSite() {
  return (
    <svg className="h-7 w-7 text-sky-700" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.75" aria-hidden>
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M3.6 9h16.8M3.6 15h16.8M12 3a14.5 14.5 0 0 1 0 18M12 3a14.5 14.5 0 0 0 0 18" />
    </svg>
  )
}

function IconAttachments() {
  return (
    <svg className="h-7 w-7 text-sky-700" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.75" aria-hidden>
      <path strokeLinecap="round" strokeLinejoin="round" d="M18.375 12.739l-7.693 7.693a4.5 4.5 0 01-6.364-6.364l10.94-10.94A3 3 0 1119.5 7.372L8.552 18.32m.009-.01l.01.01m-.01-.01l.01.01" />
    </svg>
  )
}

function IconBackups() {
  return (
    <svg className="h-7 w-7 text-sky-700" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.75" aria-hidden>
      <path strokeLinecap="round" strokeLinejoin="round" d="M20.25 6.375c0 2.278-3.694 4.125-8.25 4.125S3.75 8.653 3.75 6.375m16.5 0c0-2.278-3.694-4.125-8.25-4.125S3.75 4.097 3.75 6.375m16.5 0v11.25c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125V6.375" />
    </svg>
  )
}

function IconAi() {
  return (
    <svg className="h-7 w-7 text-sky-700" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.75" aria-hidden>
      <path strokeLinecap="round" strokeLinejoin="round" d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 00-2.456 2.456z" />
    </svg>
  )
}

function IconLoginActivity() {
  return (
    <svg className="h-7 w-7 text-sky-700" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.75" aria-hidden>
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
  )
}

function IconSecurity() {
  return (
    <svg className="h-7 w-7 text-sky-700" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.75" aria-hidden>
      <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z" />
    </svg>
  )
}

function SettingsCard({ to, title, description, icon, disabled, disabledHint }) {
  const inner = (
    <>
      <div className="mb-4">{icon}</div>
      <h2 className="text-lg font-semibold text-sky-900">{title}</h2>
      <p className="mt-2 text-sm text-brand-muted">{description}</p>
      {disabled && disabledHint && (
        <p className="mt-3 text-xs text-amber-700">{disabledHint}</p>
      )}
    </>
  )

  if (disabled || !to) {
    return (
      <div className="rounded-xl border border-slate-200 bg-white/70 p-6 opacity-70 shadow-sm">
        {inner}
      </div>
    )
  }

  return (
    <Link
      to={to}
      className="rounded-xl border border-slate-200 bg-white/90 p-6 shadow-sm transition hover:border-sky-300 hover:bg-white hover:shadow-md"
    >
      {inner}
    </Link>
  )
}

export function SettingsOverview() {
  const { isAdmin } = useAuth()
  const [params] = useSearchParams()
  const [customerId, setCustomerId] = useState(
    () => params.get('customer') || getRememberedSettingsCustomer(),
  )

  useEffect(() => {
    const fromQuery = params.get('customer')
    if (fromQuery) {
      rememberSettingsCustomer(fromQuery)
      setCustomerId(fromQuery)
    } else {
      setCustomerId(getRememberedSettingsCustomer())
    }
  }, [params])

  if (!isAdmin) {
    return <Navigate to="/" replace />
  }

  return (
    <SettingsShell title="Settings" customerId={customerId || undefined}>
      <div className="space-y-6">
        <div className="rounded-xl border border-slate-200 bg-white/90 px-8 py-8 shadow-sm">
          <h1 className="font-display text-4xl tracking-tight text-brand">
            Settings
          </h1>
          <p className="mt-2 max-w-2xl text-brand-muted">
            Manage customers, users, and category structure for this knowledge
            base.
          </p>
        </div>

        <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-3">
          <SettingsCard
            to="/settings/field-names"
            title="Field names"
            description="Edit the site title, customer label, and other labels used across the knowledge base."
            icon={<IconSite />}
          />
          <SettingsCard
            to="/settings/security"
            title="Security"
            description="Site-wide 2FA default. Turn 2FA off for individual users under Users when testing."
            icon={<IconSecurity />}
          />
          <SettingsCard
            to="/settings/login-activity"
            title="Login activity"
            description="See when customer users last signed in to view their knowledge base."
            icon={<IconLoginActivity />}
          />
          <SettingsCard
            to="/settings/attachments"
            title="Attachments"
            description="Allowed file types, maximum size, and storage used by category page attachments."
            icon={<IconAttachments />}
          />
          <SettingsCard
            to="/settings/backups"
            title="Backups"
            description="Monitor full site backups, check the nightly timer, and run a backup now."
            icon={<IconBackups />}
          />
          <SettingsCard
            to="/settings/ai"
            title="AI"
            description="Choose OpenAI or Anthropic and store an encrypted API key for AI Search."
            icon={<IconAi />}
          />
          <SettingsCard
            to="/ai-search"
            title="AI Search"
            description="Ask questions across all customer knowledge bases and jump to matching pages."
            icon={<IconAi />}
          />
          <SettingsCard
            to="/expiries"
            title="ToDo / Expiring"
            description="See open ToDo due dates and other Expiry fields (certificates, etc.) that are due soon or overdue."
            icon={<IconLoginActivity />}
          />
          <SettingsCard
            to="/settings/expiries"
            title="Expiry warning"
            description="How many days ahead an Expiry field should appear on ToDo / Expiring (default 5). Open ToDos always appear."
            icon={<IconSecurity />}
          />
          <SettingsCard
            to="/settings/telegram"
            title="Telegram"
            description="Daily ToDo / Expiring digest to your personal Telegram chat, plus a test send."
            icon={<IconLoginActivity />}
          />
          <SettingsCard
            to="/manage-customers"
            title="Customers"
            description="Add, rename, deactivate or delete customer organisations."
            icon={<IconCustomers />}
          />
          <SettingsCard
            to="/users"
            title="Users"
            description="Create admin and customer logins, grant edit rights, and reset passwords."
            icon={<IconUsers />}
          />
          <SettingsCard
            to="/manage-categories"
            title="Manage categories"
            description="Add, rename, reorder or delete sidebar categories and table fields for a chosen customer."
            icon={<IconCategories />}
          />
          <SettingsCard
            to="/settings/templates"
            title="Templates"
            description="Edit the IT and Cyber category seeds (structure and content) used when creating new customers."
            icon={<IconCategories />}
          />
        </div>
      </div>
    </SettingsShell>
  )
}
